module.exports = __webpack_public_path__ + "js/0.6b0e756a.worker.js"